module.exports = __webpack_public_path__ + "Time_Excellence_Awards_2020-9b0861f1.webp";